import QuestionsBox from '../components/questions-box';
import QuestionsForm from '../components/questions-form';
import QuestionsFilter from '../components/questions-filter';

export default {
  init() {
    var that = this;
    this.preventUpdate = false;

    // JavaScript to be fired on the questions & answers page
    this.questionsBox = new QuestionsBox($('.c-questions-box'));
    this.questionsFilter = new QuestionsFilter($('.c-questions-filter'), function(filters){
      that.questionsBox.loadFilteredQuestions(filters);
    });

    new QuestionsForm($('.c-questions-form'));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/questions.js